import React from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-cropper';

const ImageCropper = ({ crop: { image, rate }, refCropper, onCrop }) => (image ? (
  <Cropper
    ref={refCropper}
    crop={onCrop}
    src={image.url}
    style={{ height: 450 }}
    aspectRatio={rate}
    guides={false}
  />
) : null);

ImageCropper.propTypes = {
  crop: PropTypes.object,
  refCropper: PropTypes.func.isRequired,
  onCrop: PropTypes.func.isRequired,
};

export default ImageCropper;
